<template>
	<inertia-head title="Platinum Course" />
	<div class="bg-trc-main">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0 mb-3">
					<h1 class="fw-bold text-white mb-2">Platinum Course</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						Platinum Membership Training
					</h2>
				</div>
			</div>
		</div>
	</div>
	<div class="content mt-5">
		<div
			v-if="['SILVER','GOLD','DIAMOND'].includes($page.props.user.current_rank)"
			class="alert alert-warning"
		>
			<p class="fw-semibold mb-0 text-center">
				Please upgrade to PLATINUM membership level to access the courses
			</p>
		</div>
		<div v-else-if="frontVideo==null" class="row">
			<div class="col-lg-12 text-center pt-5">
				<h1>No Platinum Course Found</h1>
			</div>
		</div>
		<div v-else class="row">
			<div class="col-lg-8">
				<div class="block">
					<div class="block-content block-content-full p-0">
						<VimeoIframe :video-id="frontVideo.video_id" />
					</div>
					<div class="block-content block-content-full text-center">
						<h6>{{ frontVideo.title }}</h6>
					</div>
					<div
						class="block-content block-content-full border-top d-flex justify-content-between"
					>
						<InertiaLink
							v-if="frontVideo.prev!=null"
							:href="'/member/trc-education/platinum-course?'+frontVideo.prev"
							class="btn btn-alt-secondary"
						>
							Previous
						</InertiaLink>
						<InertiaLink
							v-if="frontVideo.next!=null"
							:href="'/member/trc-education/platinum-course?'+frontVideo.next"
							class="btn btn-alt-primary"
						>
							Next
						</InertiaLink>
					</div>
				</div>
			</div>
			<div class="col-lg-4">
				<a
					class="block block-link-shadow text-center mb-1"
					href="javascript:void(0)"
				>
					<div class="block-header border-bottom">
						<h3 class="block-title">Instructor</h3>
					</div>
					<div class="block-content block-content-full">
						<div class="push">
							<img
								class="img-avatar"
								src="/media/avatars/avatar10.jpg"
								alt=""
							/>
						</div>
						<div class="fw-semibold mb-1">{{ frontVideo.author }}</div>
						<div class="fs-sm text-muted">
							You now have the proper tools. Now let's get to the next step!
						</div>
					</div>
				</a>
				<div class="block">
					<div class="block-content p-0">
						<div class="accordion accordion-flush" id="coursesAccordion">
							<!-- Courses -->
							<div
								v-for="(course,index) in courses[0]"
								:key="course.id"
								class="accordion-item"
							>
								<h2
									class="accordion-header bg-primary"
									:id="`course-${course.id}`"
								>
									<button
										class="accordion-button bg-black-25"
										:class="{'collapsed':frontVideo.module != course.id}"
										type="button"
										data-bs-toggle="collapse"
										:data-bs-target="`#course-collapse-${course.id}`"
										aria-expanded="true"
										:aria-controls="`course-collapse-${course.id}`"
									>
										{{ course.title }}
									</button>
								</h2>
								<div
									:id="`course-collapse-${course.id}`"
									class="accordion-collapse collapse"
									:class="{ show: frontVideo.module == course.id }"
									:aria-labelledby="`course-${course.id}`"
									data-bs-parent="#coursesAccordion"
								>
									<div v-for="video in courses[course.id]" :key="video.id"
										:class="{
											'bg-primary-lighter':
												frontVideo.id == video.id
										}"
									>
										<InertiaLink
											:href="
												route('member.trc-education.platinum-course', {
													module: video.module,
													video : video.video_seq,
												})
											"
											class="text-dark"
										>
											<div class="accordion-body">
												{{ video.title }}
											</div>
										</InertiaLink>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', window.gtag_id);

import {onMounted, ref } from 'vue'
import AuthLayout from '../../../Layouts/AuthLayout'

export default {
	layout: AuthLayout,
	props: {
		frontVideo 	: Object,
		courses 	: Object,
	},
	setup(props){

		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')
		})

		return{

		}
	}
}
</script>
